<template>
  <v-text-field
    v-model="notLikePattern"
    clearable
    @keyup.enter="applyFiltersAndGetItems"
    label="Patrón QMIs NOT LIKE"
    prepend-icon="not_interested"
  />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapMutations, mapState } = createNamespacedHelpers(
  "classifier"
);

export default {
  computed: {
    ...mapState(["notLikePatternFilter"]),
    notLikePattern: {
      set(pattern) {
        this.setNotLikePatternFilter(pattern);
      },
      get() {
        return this.notLikePatternFilter;
      }
    }
  },
  methods: {
    ...mapMutations(["setNotLikePatternFilter"]),
    ...mapActions(["applyFiltersAndGetItems"])
  }
};
</script>